'use strict';

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readFloatLE('data.params.osh');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/ai-osh-parser.js